import {useState} from 'react';
import styles from './newFaq.module.scss';
import backIcon from 'images/back.png';
import {Form, Input, Spin} from 'antd';
import {useNavigate} from 'react-router-dom';
import {useMutation, useQuery} from '@apollo/client';
import ReactQuill from 'react-quill';
import '../../../../node_modules/react-quill/dist/quill.snow.css';
import {CREATE_FAQ} from 'graphql/mutations/faq';
import {GET_ALL_FAQ} from 'graphql/queries/faq';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {toast} from 'react-toastify';
import UploadImage from 'components/Startup/profile/companyImage';

const NewFaq = () => {
  const [imgUrl, setImgUrl] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [author, setAuthor] = useState('');
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('');
  const navigate = useNavigate();

  const {loading} = useQuery(GET_ALL_FAQ);
  const [createFaqInput, {loading: createFaq}] = useMutation(CREATE_FAQ);

  const fieldWidth = 730;

  const handleSave = () => {
    createFaqInput({
      variables: {
        data: {
          question: title,
          featuredImage: imgUrl,
          author,
          answer: content,
        },
      },
      refetchQueries: [{query: GET_ALL_FAQ}],
    }).then(({data: {createFaq}}) => {
      if (createFaq.__typename === 'Error') {
        toast.error(createFaq.message);
      } else {
        toast.success('Created Successfully');
        navigate('/dashboard/support/faq');
      }
    });
  };

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }
  return (
    <div>
      <div className={styles.navigation}>
        <img src={backIcon} alt="Go back" onClick={() => navigate(-1)} />
        <span>
          FAQ <span className={styles['h-style']}>/ New FAQ</span>
        </span>
      </div>
      <div className={styles.form}>
        <UploadImage
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
          setImgUrl={setImgUrl}
          large
          bucket="faq-and-learn-articles-bucket"
        />
        <Form onFinish={handleSave} layout="vertical">
          <Form.Item
            rules={[
              {
                required: false,
              },
            ]}
            label="Title"
            className={styles.field}
            name="title">
            <Input
              style={{width: fieldWidth}}
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder={'Title'}
            />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: false,
              },
            ]}
            label="Created By"
            className={styles.field}
            name="created by">
            <Input
              style={{width: fieldWidth}}
              value={author}
              onChange={e => setAuthor(e.target.value)}
              placeholder={'Created By'}
            />
          </Form.Item>
          <div className={styles['quill-container']}>
            <span>Content</span>
            <ReactQuill
              className={styles.quill}
              theme="snow"
              modules={NewFaq.modules}
              formats={NewFaq.format}
              onChange={el => setContent(el)}
              placeholder="Write Something"
              value={content}
            />
          </div>
          <SubmitButton
            handleClick={() => handleSave()}
            disabled={createFaq}
            label="Save Changes"
          />
        </Form>
      </div>
    </div>
  );
};

NewFaq.modules = {
  toolbar: [
    [{header: '1'}, {header: '2'}, {header: [3, 4, 5, 6]}, {font: []}],
    [{size: []}],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{list: 'ordered'}, {list: 'bullet'}],
    ['link'],

    ['code-block'],
  ],
};

NewFaq.format = [
  'header',
  'font',
  'size',
  'strike',
  'bold',
  'italic',
  'underline',
  'blockquote',
  'list',
  'bullet',
  'link',
  'code-block',
];

export {NewFaq};
